import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, Redirect, useParams } from 'react-router-dom';
// context
import { Context } from '../../../context/global-data-provider';
import { AdminContext } from '../../../context/admin-context';
import { MemberContext } from '../../../context/member-context';
// component
import FormMessage from '../../components/direct/form-message';
import DirectMessage from '../../components/direct-message/direct-message';
import LoadingInCenter from '../../components/loading/loading-in-center';
// query
import useGetDirect from '../../../query/useGetDirect';
// style
import style from './direct.module.css';

const LoginToAccount = () => {
  return (
    <div className="f-grow-1 wh-100 align-items-center justify-content-center">
      <h1 className="f-row d-flex text-center" style={{ padding: '0 8px' }}>
        برای دسترسی به دایرکت، لطفا وارد حساب خود شوید
      </h1>
      <Link to={'/member/login'}>
        <button type="button" className="btn br-c-p bc-b-c mt-12p">
          ورود به حساب
        </button>
      </Link>
    </div>
  );
};

const UserInfo = ({ fullname, mobile }) => {
  return (
    <div className="f-row px-16p px-sm-8p py-8p bg--gray-2">
      <div className="font-size-3">{fullname}</div>
      <div className="mx-12p">
        <a href={`tel:${mobile}`} target="_blank" className="font-size-3">
          {mobile}
        </a>
      </div>
    </div>
  );
};

const DirectBody = () => {
  const admin = useContext(AdminContext);
  const member = useContext(MemberContext);

  const { memberId } = useParams();

  const [directData, directQuery] = useGetDirect(member.auth.value ? member.info.id : memberId);
  const { user, list } = directData || {};

  if (!member.auth.value && typeof memberId === 'undefined') {
    return <Redirect to={'/admin/members'} />;
  }

  return (
    <div className={`${style.mainArea} `}>
      <div className={style.body}>
        {admin.auth.value && <UserInfo fullname={user?.fullname} mobile={user?.mobile} />}

        <div className={style.wrapper}>
          <LoadingInCenter show={directQuery.isLoading} fill="#555" width={28} height={28} blur />

          {list &&
            Object.keys(list).map((key) => {
              return (
                <div key={key}>
                  <div className={style.dateGroup}>
                    <span>
                      <span className={'font-size-2 color-gray bg--gray-1'}>{key}</span>
                    </span>
                  </div>
                  {list[key].map((data, index) => (
                    <DirectMessage key={data.id} admin={admin} member={member} data={data} index={index} />
                  ))}
                </div>
              );
            })}

          {
            // list && list.map( ( data, index ) => <DirectMessage key={ data.id } admin={ admin } member={ member } data={ data } index={ index }/> )
          }
        </div>

        <FormMessage isAdmin={admin.auth.value} memberId={member.auth.value ? member.info.id : memberId} />
      </div>
    </div>
  );
};

export default function Direct() {
  const { setCurrentRoute, options } = useContext(Context);
  const admin = useContext(AdminContext);
  const member = useContext(MemberContext);

  useEffect(() => {
    setCurrentRoute('/direct');
  }, [setCurrentRoute]);

  return (
    <>
      <Helmet>
        <title>{options.title + ' • ' + 'دایرکت'}</title>
      </Helmet>

      {admin.auth.value || member.auth.value ? <DirectBody /> : <LoginToAccount />}
    </>
  );
}
